import { Portal } from '@components/common/Portal/Portal';
import useToasts from '@store/toastsStore/hooks/useToasts';
import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';
import { DEFAULT_TRANSITION_TIMEOUT } from 'src/utils/variables';
import { Toast } from '../Toast/Toast';
import { TransitionGroupEx } from './Toasts.styles';

const Toasts: FC = () => {
	const [toasts] = useToasts();

	return (
		<Portal>
			<TransitionGroupEx component='ul'>
				{toasts.map((toast) => (
					<CSSTransition key={toast.uuid} classNames='fade-toast' timeout={DEFAULT_TRANSITION_TIMEOUT['400']}>
						<Toast {...toast} />
					</CSSTransition>
				))}
			</TransitionGroupEx>
		</Portal>
	);
};

export { Toasts };
